import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/helper';
import v1 from './dialog-article-v1.module.css';
import v2 from './dialog-article-v2.module.css';

export default function DialogArticle(props: PropsWithChildren) {
  return <div className={cn(v1.DialogArticle, v2.DialogArticle)}>{props.children}</div>;
}
